import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../config';
import ViewReportResponsesModal from './ViewReportResponsesModal';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
import { useConfirm } from '../ConfirmProvider';
// NOTE: this component is currently DEAD CODE — setShowManageReportsModal(true) is never
// called anywhere in frontend/src (HealthTab renders it at :373 but nothing opens it).
// Converted anyway so no window.confirm survives the sweep; it is logged in SPRINT_BACKLOG
// as a dead-code removal candidate, and deleting the file supersedes this.
function ManageReportsModal({ onClose, fetchWithAuth }) {
  const confirm = useConfirm();
  useEscapeToClose(onClose);   // Escape dismisses this modal
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showResponsesModal, setShowResponsesModal] = useState(false);

  const [accessHistory, setAccessHistory] = useState([]);  // P-004 claim 18

  useEffect(() => {
    loadReports();
    loadAccessHistory();
  }, []);

  // P-004 claim 18: patient-facing provider-access event history (validate/revoke)
  const loadAccessHistory = async () => {
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/reports/access-history`);
      if (response.ok) {
        const data = await response.json();
        setAccessHistory(data.events || []);
      }
    } catch (error) {
      console.error('Failed to load access history:', error);
    }
  };

  const loadReports = async () => {
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/reports/user-reports`);
      if (response.ok) {
        const data = await response.json();
        //console.log('DEBUG - REPORTS DATA:', data);
        //console.log('DEBUG - REPORTS LENGTH:', data.length);
        setReports(data);
      }
    } catch (error) {
      console.error('Failed to load reports:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteReport = async (reportId) => {
    if (!(await confirm({
      title: 'Delete this report?',
      message: 'The report and all associated responses will be permanently deleted. This cannot be undone.',
      confirmLabel: 'Delete Report',
      destructive: true,
    }))) {
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_BASE}/api/reports/${reportId}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        setReports(prev => prev.filter(r => r.id !== reportId));
      } else {
        alert('Failed to delete report.');
      }
    } catch (error) {
      console.error('Failed to delete report:', error);
      alert('An error occurred.');
    }
  };

  const handleViewResponses = (report) => {
    setSelectedReport(report);
    setShowResponsesModal(true);
  };

  if (showResponsesModal) {
    return (
      <ViewReportResponsesModal
        reportId={selectedReport.id}
        onClose={() => {
          setShowResponsesModal(false);
          setSelectedReport(null);
        }}
        fetchWithAuth={fetchWithAuth}
      />
    );
  }

  return (
   <div className="modal-overlay">
      <div className="modal-content modal-content-xl">
       <div className="modal-header">
          <h2 className="m-0">Manage Reports</h2>
          <button onClick={onClose} className="modal-close text-white">&times;</button>
        </div>

        <div className="modal-body">
          {loading && <div>Loading...</div>}

          {!loading && reports.length === 0 && (
            <div className="empty-state-lg">
              <div className="text-48 mb-20">📋</div>
              <h3>No Reports Yet</h3>
              <p>Reports you send will appear here.</p>
            </div>
          )}

          {!loading && reports.map((report) => (
            <div key={report.id} className="report-card p-20">
              <div className="flex-between-center mb-15">
                <div>
                  <h3 className="m-0-0-10-0">{report.report_title}</h3>
                  <div className="text-14 text-gray-500">
                    Sent: {new Date(report.created_at).toLocaleDateString()}
                  </div>
                </div>
                <div className="flex gap-3">
                  <button onClick={() => handleViewResponses(report)}
                  className="btn btn-secondary btn-sm">
                    View
                  </button>
                  <button onClick={() => handleDeleteReport(report.id)}
                  className="btn btn-danger btn-sm">
                    Delete
                  </button>
                </div>
              </div>

              <div className="text-13 text-gray-600">
                <strong>Providers:</strong> {report.provider_names?.join(', ') || 'N/A'}
              </div>

              {report.data_elements_included && (
                <div className="mt-10 text-13 text-gray-500">
                  <strong>Data Included:</strong> {Object.keys(report.data_elements_included).filter(k => report.data_elements_included[k]).join(', ')}
                </div>
              )}
            </div>
          ))}

          {accessHistory.length > 0 && (
            <div className="report-card p-20 mt-15">
              <h3 className="m-0-0-10-0">Provider Access History</h3>
              <div className="text-13 text-gray-600">
                {accessHistory.map((ev, i) => (
                  <div key={i} className="flex-between-center py-1">
                    <span>
                      <strong>{ev.event === 'VALIDATE' ? 'Accessed' : ev.event === 'REVOKE' ? 'Revoked' : ev.event}</strong>
                      {ev.report_title ? ` — ${ev.report_title}` : ''}
                    </span>
                    <span className="text-gray-500">{ev.at ? new Date(ev.at).toLocaleString() : ''}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManageReportsModal;
